import React from 'react';
import LoadModalBodyEnd from './LoadModalBodyEnd';
import './OverFlowTooltip.css'

export default class TooltipThumb extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowToolTip: false,
            mousePos: {
                x: 0,
                y: 0
            },
        }

        this.hideToolTipTimer = null;
        this.textRefElement = null;

        this.tooltipSize = this.computeToltipSize();
    }

    _onMouseLeaveHandler = () => {
        this.resetTooltipTimeout();
        if (this.state.isShowToolTip) {
            this.setState({ isShowToolTip: false });
        }
    }

    resetTooltipTimeout = () => {
        if (this.hideToolTipTimer) {
            clearTimeout(this.hideToolTipTimer);
            this.hideToolTipTimer = null;
        }
    }

    setTootipTimeout = (callback) => {
        if (!this.hideToolTipTimer) {
            this.hideToolTipTimer = setTimeout(callback, 100);
        }
    }

    /**
     * 
     * @param {MouseEvent} evt 
     */
    _onMouseMoveHandler = (evt) => {
        let x = evt.pageX + 7;
        let y = evt.pageY + 7;

        let { isPublicKnowledge } = this.props; 
        if (isPublicKnowledge) {
            x = evt.pageX + 7;
            y = evt.pageY - 7;
        }

        if (this.isOverflowX(x)) {
            x -= (this.tooltipSize.width + 10);
        }

        if (this.isOverFlowY(y)) {
            y -= (this.tooltipSize.height + 10);
            if (isPublicKnowledge) {
                y += (this.tooltipSize.height + 30);
            }
        }

        this.showTooltipAtPos(x, y);
    }

    showTooltipAtPos = (x, y) => {
        if(!this.state.isShowToolTip) {
            this.setTootipTimeout(() => {
                this.setState({ isShowToolTip: true, mousePos: { x, y } });
                this.resetTooltipTimeout();
            });
        }

        if (this.state.isShowToolTip) {
            this.setState({ mousePos: { x, y }});
        }
    }


    isOverflowX = (x) => {
        return x + this.tooltipSize.width >= document.body.offsetWidth;
    }

    isOverFlowY = (y) => {
        return y + this.tooltipSize.height >= document.body.offsetHeight;
    }

    computeToltipSize = () => {
        let size = { width: 0, height: 0 };
        if (!this.props.value) {
            return size;
        }
        let text = document.createElement("span"); 
        text.style.cssText = `
            text-align: left;
            border-radius: 3px;
            padding: 5px 6px;
        `;
        text.style.height = 'auto'; 
        text.style.width = 'auto'; 
        text.style.position = 'absolute'; 
        text.style.whiteSpace = 'pre-line';
        text.style.maxWidth = '290px';
        text.style.wordBreak = 'break-all';
        text.innerHTML = this.props.value;

        document.body.appendChild(text); 
        size.width = Math.ceil(text.clientWidth); 
        size.height = Math.ceil(text.clientHeight);
        document.body.removeChild(text);

        return size;
    }

    componentDidUpdate(prevProps) {
        if (this.props.value && prevProps.value !== this.props.value) {
            this.tooltipSize = this.computeToltipSize();
        }
    }

    componentWillUnmount() {
        this.resetTooltipTimeout();
    }
    

    setTextRefElement = (ref) => {
        this.textRefElement = ref;
    }
    
    render() {
        const { isShowToolTip } = this.state;
        const { value, className, onClick } = this.props;
        return (
            <React.Fragment>
                <div 
                    ref={this.setTextRefElement} 
                    className={`overFlow-lineHeight ${className ? className: ''}`} 
                    onMouseMove={this._onMouseMoveHandler} 
                    onMouseLeave={this._onMouseLeaveHandler}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    onClick={onClick}
                >
                    {this.props.children ? this.props.children : value}
                </div>
                {isShowToolTip && <LoadModalBodyEnd>
                    <span className="noselect" style={{
                        position: 'absolute',
                        left: this.state.mousePos.x,
                        top: this.state.mousePos.y,
                        fontSize: 10,
                        width: 'auto',
                        height: 'auto',
                        zIndex: 99999,
                        whiteSpace: 'pre-line',
                        maxWidth: 290,
                        "textAlign": "center",
                        "borderRadius": "3px",
                        "padding": "5px 6px",
                        "backgroundColor": "#6D6D6E",
                        "color": "#fff",
                        "WebkitBoxShadow": "0px 2px 3px -1px rgba(156, 155, 155, 0.9)",
                        "MozBoxShadow": "0px 2px 3px -1px rgba(156, 155, 155, 0.9)",
                        "boxShadow": "0px 2px 3px -1px rgba(156, 155, 155, 0.9)",
                        "wordBreak" : "break-all"

                    }}>{value}</span>
                </LoadModalBodyEnd>}
            </React.Fragment>
        )
    }
}
